import React from 'react'
import { useTranslation } from 'react-i18next'

import "./apiSecurity.scss"
import Section from '../../../../components/utils/SectionComponent'

function ApiSecurity() {
  const { t } = useTranslation()
  return (
    <div className='container-api-security'>
      <div className='texts-api-security'>
        <Section title={t("security.rest_api.title")} text={t("security.rest_api.section_text")} />
      </div>
    </div>
  )
}

export default ApiSecurity